import autowebStore from "./vuex";
import routes from "./router";
import "./assets/style/editorTheme.scss";
/**
 *  将不同的业务模块按照module分开, 每个模块将自身公开为一个插件, 在install方法中，负责注册自身的相关资源
 *  可视化编辑模块
 */
// (function (doc, win) {
//   var radio = win.devicePixelRatio || 1,
//       scale = 1 / radio,
//       docEl = doc.documentElement,
//       meta = document.createElement("meta"),
//       resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
//       recalc = function () {
//           var clientWidth = docEl.clientWidth;
//           if (!clientWidth) return;
//           docEl.style.fontSize = 100 * (1440 / 1920) + "px";
//       };
//   recalc();
//   docEl.setAttribute("data-dpr", radio);
//   meta.setAttribute("name", "viewport");
//   if (docEl.firstElementChild) docEl.firstElementChild.appendChild(meta);
//   if (!doc.addEventListener) return;
//   win.addEventListener(resizeEvt, recalc, false);
//   doc.addEventListener("DOMContentLoaded", recalc, false);
// })(document, window);
   (function () {
        /**
         * resize
         * @description: 根据屏幕宽度resize根html的fontsize
         * @param {number} w - 屏幕宽度
         * @param {number} max - 最大宽度
         */
        var resize = function () {
          let w = document.documentElement.clientWidth,
            max = 970;
          if (w < 768) {
            document.documentElement.removeAttribute("style");
            $("html").addClass("m");
          } else {
            if (w >= 1185) {
              max = 1200;
            }
            document.documentElement.style.fontSize = (max / 240) * 10 + "px";
            $("html").removeClass("m");
          }
        };
        window.addEventListener
          ? window.addEventListener("resize", resize)
          : window.attachEvent("resize", resize);
        resize();
      })();
export default {
  install(Vue, { store, router }) {
    router.addRoutes(routes);
    store.registerModule("autowebStore", autowebStore);
  }
};
